<div *ngIf="CanShow === 1 ">
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
      <div class="card" *ngIf="CurrentActorProfileSummaryInfoController.ActorCode >0">
        <div class="card-header wh-header">
          <div class="row">
            <div class="col-md-10 pink">
              PROFILE SUMMARY
            </div>
            <div class="col-md-2 float-right" *ngIf="CanEdit === 1 ">
              <a (click)="OpenEditContent()"><span class="badge badge-pink"> <i class="fa fa-edit"></i></span></a>
            </div>
          </div>
        </div>
        <!--<div class="card-header">
          <h5>Profile Summary</h5>
          <div class="col-12 fonticon-container">
            <div class="fonticon-wrap">
              <button class="ft-edit" (click)="OpenEditContent()"> </button>
            </div>

          </div>
        </div>-->
        <div class="card-body">
          <div class="card-block">
            <div class="media mb-1">
              <div class="media-body">
                <h4 class="font-medium-1 mt-1 mb-1">{{CurrentActorProfileSummaryInfoController.ProfileSummary}}</h4>
                <!--<p class="text-muted font-small-3 mb-1 pink">{{l.CredentialType}}, {{l.IssuingAuthorityLongValue}}</p>
                <p class="text-muted font-small-2">{{l.CredentialNumber}}</p>-->
              </div>
            </div>
            <!--<div class="row">

              <div class="col-12">
                <ul class="no-list-style">
                  <li class="mb-2" *ngIf="CurrentActorProfileSummaryInfoController.ProfileSummary">
                    <span class="text-bold-500 primary"><a><i class="icon-present font-small-3"></i> ProfileSummary:</a></span>
                    <span class="display-block overflow-hidden">{{CurrentActorProfileSummaryInfoController.ProfileSummary}}</span>
                  </li>


                </ul>
              </div>

            </div>-->
          </div>
        </div>
      </div>
      </div>
    </div>
    </div>



    <div *ngIf="CanShowRegistryView === 1  && CurrentActorProfileSummaryInfoController">
      <div class="row margin-left-15">
        <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">

          <div class="card profile" *ngIf="CurrentActorProfileSummaryInfoController.ActorCode >0">

            <div class="card-header wh-header">
              <div class="row">
                <div class="col-md-10 pink">
                  Profile Summary
                </div>

              </div>
            </div>

            <div class="card-body">
              <div class="card-content">
                <div class="card-block">
                  <div class="media-body">
                    <h4 class="font-medium-1 mt-1 mb-1">{{CurrentActorProfileSummaryInfoController.ProfileSummary}}</h4>

                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

